<template>
    <div class="fansMgt spackage padding-20 bgc box-shadow">
        <div>
            <el-tabs v-model="activeIndex">
                <el-tab-pane label="订单粉丝" name="order">
                    <OrderManagement></OrderManagement>
                </el-tab-pane>
                <el-tab-pane label="公众号粉丝" name="gzh">
                     <GzhManagement></GzhManagement>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import OrderManagement from './subPage/OrderManagement.vue'
    import GzhManagement from './subPage/GzhManagement.vue'

    export default {
    name: 'fansMgt',
    data() {
        return {
            activeIndex: 'order', // 默认显示导航菜单
        }
    },
    mounted() {
    },
    methods: {
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        OrderManagement,
        GzhManagement
    }
    // components: {Loading}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fansMgt {
    }
</style>
